import { useState, useEffect } from 'react';
import { _StatesCatalog } from '../../../../../core/services/dataBean/EntityCatalogVdos';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _single } from '../../../../../core/services/dataBean/EntityCatalog';
import useModal, { MODAL_md } from '../../../../theme/Component/hooks/useModal';
import usePaginator from '../../../../theme/Component/usePaginator';
import { Modal } from '../../../../theme/Component/Modal';
import { BasicButton } from '../../../../theme/Component/BasicButton';
import { BasicTable } from '../../../../theme/Component/BasicTable';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
    idCountries: any
}

export const StatesCatalogEditor = ({ idSelector, onChange, label, returnType = "ID", render, idCountries }: Props) => {

    const { instance, lista, setLista } = useDataBean(_StatesCatalog)
    const [id, setID] = useState(null);
    const [Account, setAccount] = useState<number>(null)
    const [regexStr, setregexStr] = useState<any>(null)
    const [month, setMonth] = useState<any>(null);
    const [year, setYear] = useState<any>(_single.getCurrenYear());
    const modal = useModal("Estados", MODAL_md);
    const paginador = usePaginator();

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])


    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDStates == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        instance.getStatesCatalog(idCountries, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDStates', visible: true },
        { title: 'País', property: 'CountryName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo', property: 'TypeState', visible: true },
        { title: 'Latitud', property: 'Latitude', visible: true },
        { title: 'Longitud', property: 'Longitude', visible: true },
        { title: 'Código de Estado', property: 'StateCode', visible: true },

    ]
    const abrirModal = () => {
        modal.open();
    }

    return (
        <>
            <label>{label ?? "Estados"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <label>Búsqueda por Texto</label>
                        <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-6 mt-4 p-2">
                        <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDStates); modal.close(); }} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    </div>
                </div>

            </Modal>
        </>
    )
}